module.exports = __webpack_public_path__ + "img/dinkenclave-7.3a7bdcc6.jpeg";